// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_FGvV6,.left_gx9Ay,.right_fglUE{position:relative;display:flex;align-items:center}.container_FGvV6{color:#272525;width:100%}.left_gx9Ay>*,.right_fglUE>*{margin-left:15px}.left_gx9Ay{flex:1}.right_fglUE>:last-child{margin-right:15px}.product-image_9vysm{max-height:38px;max-width:38px}.product-title_pihDd{font-size:13px;font-weight:400}", ""]);
// Exports
exports.locals = {
	"container": "container_FGvV6",
	"left": "left_gx9Ay",
	"right": "right_fglUE",
	"product-image": "product-image_9vysm",
	"product-title": "product-title_pihDd"
};
module.exports = exports;
